import React, { useRef, useEffect, useState } from "react";
import Button from "../Buttons/Button";
import SmartTooltip from "./SmartTooltip";
import Modal from "../Modal/Modal";
import LogoLoader from "../Loading/LogoLoader";

const CardWithButton = ({
  title,
  description,
  category,
  type,
  onSetup,
  onConfigure,
  isAdded,
  buttonLoading
}) => {
  const [showDescription, setShowDescription] = useState(false);
  const titleRef = useRef(null);
  const descRef = useRef(null);
  const [isTitleOverflowed, setIsTitleOverflowed] = useState(false);
  const [isDescOverflowed, setIsDescOverflowed] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
      setIsTitleOverflowed(
        titleRef.current.scrollHeight > titleRef.current.clientHeight
      );
    }
    if (descRef.current) {
      setIsDescOverflowed(
        descRef.current.scrollHeight > descRef.current.clientHeight
      );
    }
  }, [title, description]);

  const handleButtonClick = () => {
    if (isAdded && onConfigure) {
      onConfigure(category, type);
    } else if (!isAdded && onSetup) {
      onSetup(category, type, false);
    }
  };

  return (
    <>
      <div className="px-4 py-4 text-black flex flex-col justify-between gap-3 self-start w-full h-46 border border-gray-100 rounded-md bg-white shadow-sm">
        <div className="flex flex-col gap-3">
          <div>
            {isTitleOverflowed ? (
              <SmartTooltip
                noicon={true}
                description={title}
                variant="outlined"
              >
                {typeof title !== "string" ? (
                  <div className="line-clamp-1">{title}</div>
                ) : (
                  <h5 className="line-clamp-1">{title}</h5>
                )}
              </SmartTooltip>
            ) : typeof title !== "string" ? (
              <div className="line-clamp-1">{title}</div>
            ) : (
              <h5 ref={titleRef} className="line-clamp-1">
                {title}
              </h5>
            )}
          </div>

          <div>
            <div ref={descRef} className="line-clamp-2 text-xs">
              {description}
            </div>
            {isDescOverflowed && (
              <button
                className="bg-transparent border-0 outline-none text-primary hover:text-primary-600 text-xs"
                onClick={() => setShowDescription(true)}
              >
                Read more
              </button>
            )}
          </div>
        </div>

        <div className="self-end flex gap-2">
          {buttonLoading ? <LogoLoader /> : (
            <Button
              title={isAdded ? "Configure" : "Setup"}
              type="button"
              variant="outlined"
              size="sm"
              color="primary"
              onClick={handleButtonClick}
              className="hover:opacity-90"
            />
          )}          
        </div>
      </div>

      <Modal
        isOpen={showDescription}
        onClose={() => setShowDescription(false)}
        title={typeof title === "string" ? title : "Details"}
        width="max-w-4xl"
        closeOnOutsideClick
      >
        <div>{description}</div>
      </Modal>
    </>
  );
};

export default CardWithButton;
